import { Link } from "react-router-dom";
import { latestStories, hotStories, formatCount } from "@/lib/content";

export default function HeroHot() {
  const latest = latestStories();
  const featured = latest[0];
  const second = latest[1];
  const hot = hotStories(5);

  return (
    <section className="mx-auto max-w-7xl px-4 pt-8 md:px-6 md:pt-12">
      <div className="overflow-hidden rounded-2xl bg-gradient-to-br from-background-100 via-background-50 to-secondary-100">
        <div className="px-5 py-8 md:px-10 md:py-10">
          <div className="max-w-3xl">
            <h1 className="font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
              校园瓜田，今日又有新料
            </h1>
            <p className="mt-3 text-sm leading-6 text-foreground-700 md:text-base">
              恋爱故事、表白现场、分手复盘与情侣纠纷，最新现场直击，天天更新——这里是一站式满足吃瓜好奇心的校园情感情报站。
            </p>
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3.5 py-1.5 text-sm font-medium text-background-50">
              <i className="ri-flashlight-line text-base" aria-hidden="true" />
              今日新鲜瓜
            </span>
            <span className="inline-flex items-center gap-1.5 text-sm text-foreground-600">
              <i className="ri-calendar-line text-base text-accent-600" aria-hidden="true" />
              更新于 {featured.date} · 全天滚动
            </span>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-5">
            {/* featured big */}
            <Link
              to={`/story/${featured.slug}`}
              className="group relative block overflow-hidden rounded-xl lg:col-span-3"
              title={`${featured.title} - 大学吃瓜`}
            >
              <div className="aspect-[16/9] w-full overflow-hidden lg:aspect-auto lg:h-full lg:min-h-[360px]">
                <img
                  src={featured.cover}
                  alt={featured.title}
                  title={`${featured.title} - 大学吃瓜`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <span className="inline-block rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">头号热瓜</span>
                <h2 className="mt-3 max-w-2xl font-heading text-xl font-black leading-snug text-background-50 md:text-3xl">{featured.title}</h2>
                <p className="mt-2 hidden max-w-2xl text-sm leading-6 text-background-200 md:block">{featured.summary}</p>
                <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-background-200">
                  <span className="flex items-center gap-1.5"><i className="ri-eye-line" aria-hidden="true" />{formatCount(featured.views)} 围观</span>
                  <span className="flex items-center gap-1.5"><i className="ri-heart-3-line text-primary-300" aria-hidden="true" />{formatCount(featured.likes)} 点赞</span>
                  <span className="flex items-center gap-1.5"><i className="ri-chat-3-line" aria-hidden="true" />{featured.comments} 条热评</span>
                </div>
              </div>
            </Link>

            {/* right column: second story + hot list */}
            <div className="flex flex-col gap-5 lg:col-span-2">
              <Link to={`/story/${second.slug}`} className="group flex gap-4 overflow-hidden rounded-xl bg-background-50 p-3" title={second.title}>
                <div className="h-24 w-28 shrink-0 overflow-hidden rounded-lg sm:h-28 sm:w-36">
                  <img src={second.cover} alt={second.title} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="flex min-w-0 flex-col justify-center pr-1">
                  <span className="text-[11px] font-medium text-accent-700">次席热瓜</span>
                  <h3 className="mt-1 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-700">{second.title}</h3>
                  <span className="mt-2 text-xs text-foreground-500">{second.date}</span>
                </div>
              </Link>

              <div id="hot" className="rounded-xl bg-background-50 p-4 md:p-5">
                <h3 className="flex items-center gap-2 font-heading text-base font-black text-foreground-950">
                  <i className="ri-fire-fill text-lg text-primary-500" aria-hidden="true" />
                  热度排行榜
                </h3>
                <ol className="mt-3 space-y-2">
                  {hot.map((s, i) => (
                    <li key={s.slug}>
                      <Link to={`/story/${s.slug}`} className="group flex items-center gap-3 rounded-lg px-2 py-2 transition-colors hover:bg-background-200/60" title={s.title}>
                        <span
                          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-black ${
                            i === 0 ? "bg-primary-500 text-background-50" : i === 1 ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                          }`}
                        >
                          {i + 1}
                        </span>
                        <span className="min-w-0 flex-1 truncate text-sm text-foreground-700 group-hover:text-primary-700">{s.title}</span>
                        <span className="shrink-0 text-xs text-foreground-400">{s.heat}.0</span>
                      </Link>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}